<div class="agentic-ecommerce">
  <div class="agentic-ecommerce-header">
    <h1>Agentic Ecommerce</h1>
    <p>
      How AI shopping assistants see your store &mdash; compared with real
      shoppers.
    </p>
  </div>

  <ng-container *ngIf="isLoading; else experimentContent">
    <div class="agentic-section-label skeleton-label"></div>

    <div class="agentic-agent-grid agentic-agent-grid-skeleton">
      <div
        class="agentic-skeleton-card"
        *ngFor="let skeleton of skeletonAgentCards"
      >
        <span class="agentic-skeleton icon"></span>
        <span class="agentic-skeleton line title"></span>
        <span class="agentic-skeleton score"></span>
        <span class="agentic-skeleton line"></span>
        <span class="agentic-skeleton line short"></span>
      </div>
    </div>

    <div class="agentic-skeleton-panel"></div>

    <div
      class="agentic-page-skeleton"
      *ngFor="let pageSkeleton of skeletonPageCards"
    >
      <div class="agentic-page-skeleton-header">
        <span class="agentic-skeleton pill"></span>
        <span class="agentic-skeleton line title"></span>
        <span class="agentic-skeleton line small"></span>
      </div>
      <div class="agentic-product-skeleton-grid">
        <span
          class="agentic-skeleton product"
          *ngFor="let productSkeleton of skeletonProducts"
        ></span>
      </div>
    </div>
  </ng-container>

  <ng-template #experimentContent>
    <div class="agentic-state-card error" *ngIf="errorMessage">
      <div class="state-icon">
        <mat-icon>error_outline</mat-icon>
      </div>
      <div class="state-copy">
        <h2>Experiment unavailable</h2>
        <p>{{ errorMessage }}</p>
      </div>
      <button mat-stroked-button type="button" (click)="retry()">
        <mat-icon>refresh</mat-icon>
        <span>Retry</span>
      </button>
    </div>

    <div class="agentic-state-card" *ngIf="!errorMessage && !hasProducts">
      <div class="state-icon">
        <mat-icon>inventory_2</mat-icon>
      </div>
      <div class="state-copy">
        <h2>No products found</h2>
        <p>
          The crawler did not return product pages for this audit yet. Once HTML
          extraction finds products, they will appear here.
        </p>
      </div>
    </div>

    <ng-container *ngIf="!errorMessage && hasProducts">
      <div class="agentic-section-label">
        <mat-icon>smart_toy</mat-icon>
        <span>Select an AI agent to audit</span>
      </div>

      <app-agentic-agent-selector
        [agents]="agentOptions"
        [selectedAgentKey]="selectedAgentKey"
        (agentSelected)="selectAgent($event)"
      ></app-agentic-agent-selector>

      <div class="agentic-state-card" *ngIf="!hasAgents">
        <div class="state-icon">
          <mat-icon>smart_toy</mat-icon>
        </div>
        <div class="state-copy">
          <h2>No agent data yet</h2>
          <p>
            Products were extracted from HTML, but there are no AI agent results
            available for this audit yet.
          </p>
        </div>
      </div>

      <ng-container *ngIf="hasAgents">
        <app-agentic-explanation-panel></app-agentic-explanation-panel>

        <section class="agentic-products-section">
          <div class="agentic-products-header">
            <div>
              <h2>Which products {{ selectedAgentLabel }} can&rsquo;t see</h2>
              <p>
                All crawled pages below. Greyed-out tiles are products
                {{ selectedAgentLabel }} never receives, because they load via
                JavaScript.
              </p>
            </div>

            <div class="agentic-segmented-control" role="group">
              <button
                type="button"
                [class.active]="productFilter === 'all'"
                (click)="setProductFilter('all')"
              >
                All products
              </button>
              <button
                type="button"
                [class.active]="productFilter === 'missing'"
                (click)="setProductFilter('missing')"
              >
                Only missing
              </button>
            </div>
          </div>

          <div
            class="agentic-state-card compact"
            *ngIf="productFilter === 'missing' && !visiblePages.length"
          >
            <div class="state-icon success">
              <mat-icon>visibility</mat-icon>
            </div>
            <div class="state-copy">
              <h2>No missing products for {{ selectedAgentLabel }}</h2>
              <p>
                Every extracted product is visible to the selected AI assistant.
              </p>
            </div>
          </div>

          <ng-container *ngIf="visiblePages.length">
            <app-agentic-page-group
              *ngFor="let page of visiblePages; trackBy: trackByPage"
              [page]="page"
              [selectedAgentKey]="selectedAgentKey"
              [selectedAgentLabel]="selectedAgentLabel"
              [showMissingOnly]="productFilter === 'missing'"
            ></app-agentic-page-group>
          </ng-container>
        </section>
      </ng-container>
    </ng-container>
  </ng-template>
</div>
